import { InvalidUrlError } from '../../errors/errors';
import { BaseGQLService } from '../../services/BaseGQLService';
import { FilterOperator } from '../../types/gql-types';
import { CursorInfo, PaginationResult } from '../../types/pagination';
import { ModelType } from '../../utils/GQLIdEncoder';
import { KeyOperationMapper } from '../mappers/KeyOperationMapper';
import { KeyOperation } from '../models/KeyOperation';

export const KEY_OPERATIONS_FRAGMENT = `
pageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
edges {
  node {
    id
    type
    context
    algorithms
    keyRoles
    report {
      id
    }
  }
}
totalCount
`;

export const GET_KEY_OPERATIONS_QUERY = `
query (
  $keyId: ID!,
  $first: Int,
  $last: Int,
  $after: String,
  $before: String
) {
  node(id: $keyId) {
    ... on Key {
      operations(
        first: $first,
        last: $last,
        after: $after,
        before: $before
      ) {
        ${KEY_OPERATIONS_FRAGMENT}
      }
    }
  }
}`;

export class KeyOperationsService extends BaseGQLService {
  private readonly mapper = new KeyOperationMapper();

  async getKeyOperations(keyId: number, cursor: CursorInfo, filters: FilterOperator | null): Promise<PaginationResult<KeyOperation>> {
    return this.query(
      GET_KEY_OPERATIONS_QUERY,
      {
        keyId: this.gqlIdEncoder.encode(ModelType.Key, keyId),
        ...this.mapCursorInfo(cursor),
        filters,
      },
      (data) => {
        if (!data.node) {
          throw new InvalidUrlError(`Invalid request: could not find Key ${keyId}`);
        }
        const { edges: operations, pageInfo, totalCount } = data.node.operations;
        return {
          data: operations.map((operation: any) => this.mapper.mapGQLModel(operation.node)),
          pageInfo,
          totalCount,
        };
      }
    );
  }
}
